import countries from "world-countries";

// world-countries usa chaves ISO 639-3 pras traduções; "eng" nem existe lá
// porque o nome em inglês já é o c.name.common.
const LANG_KEY = { pt: "por", es: "spa" };

export const ISO_CODES = countries.map((c) => c.cca2).sort();

export const getCountryOptions = (lang) => {
  const shortLang = (lang || "").slice(0, 2).toLowerCase();
  const key = LANG_KEY[shortLang];

  return countries
    .map((c) => ({
      code: c.cca2,
      name: (key && c.translations[key]?.common) || c.name.common,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

// DDI a partir do código ISO. A maioria dos países tem um único "suffix" que
// completa o root (ex: BR root "+5" + suffix "5" = "+55"). Países que
// compartilham o mesmo root (NANP: EUA/Canadá/Caribe com "+1"; Cazaquistão
// com "+7" etc.) têm vários suffixes curtos que na verdade são códigos de
// área, não variações do DDI — nesse caso o DDI de verdade é só o root.
export const getCallingCode = (iso2) => {
  const country = countries.find((c) => c.cca2 === iso2);
  if (!country?.idd?.root) return "";

  const { root, suffixes = [] } = country.idd;
  const code = suffixes.length === 1 ? `${root}${suffixes[0]}` : root;
  return code.replace("+", "");
};

// Label "BR (+55)" pra exibição (ex: dropdown da planilha de import). Puramente
// visual — quem consome o valor de volta deve extrair só o código ISO (ver
// extractIsoCode), nunca guardar/enviar esse label formatado.
// ISO vem primeiro de propósito: o dropdown nativo do Excel/Sheets só filtra
// por digitação a partir do INÍCIO de cada item da lista — colocar o DDI
// primeiro (formato "(+55) BR") quebra o "digitar BR pra filtrar" que existia
// antes, porque nenhum item passa a começar com "BR".
export const formatCountryWithDDI = (iso2) => {
  const ddi = getCallingCode(iso2);
  return ddi ? `${iso2} (+${ddi})` : iso2;
};

// Inverso de formatCountryWithDDI: extrai só o código ISO de 2 letras de uma
// string que pode estar no formato atual ("BR (+55)"), no formato antigo
// ("(+55) BR", de arquivos já baixados antes dessa mudança de ordem) ou no
// formato puro ("BR"). Tenta o início da string primeiro (formato atual/puro),
// cai pro final se não achar (formato antigo).
export const extractIsoCode = (value) => {
  const trimmed = String(value || "").trim().toUpperCase();
  const leadingMatch = trimmed.match(/^([A-Z]{2})(?:\s|\(|$)/);
  if (leadingMatch) return leadingMatch[1];
  const trailingMatch = trimmed.match(/([A-Z]{2})\s*$/);
  return trailingMatch ? trailingMatch[1] : trimmed;
};
